import { CheckCircle2 } from 'lucide-react';
import { pickCss } from '@/shared/lib/css-utils';
import { Text } from '@/shared/ui';
import { useAgentPanelStore } from '../model/use-agent-panel-store';
import css from './page-action-status.module.scss';

const styles = pickCss(css, css.root);

// Always-visible chip pinned just above the input that reflects the
// most-recent page-action result the panel handled (currently only
// `apply_filters` from /products). Survives close/reopen and new
// conversation turns; the trash button in the header is the way to
// clear it.
//
// Visually distinct from assistant bubbles — accent border, smaller
// type, leading checkmark — so the consultant sees it as an
// always-on status indicator, not as part of the chat.
export const PageActionStatus = () => {
  const status = useAgentPanelStore((s) => s.lastPageAction);
  if (!status) return null;
  return (
    <div className={styles({ kind: status.kind })} role="status">
      <CheckCircle2 aria-hidden="true" className={css.icon} size={14} />
      <Text as="span" size="sm" weight="medium">
        {status.summary}
      </Text>
    </div>
  );
};
